import { formatShortDate } from '@/utils/date-util';
import { localDayAt } from '@/utils/time-zone';

/**
 * A hiring goal date as the calendar day it falls on at the opening, so every
 * viewer reads the same day whatever their browser's zone. An unknown zone
 * falls back to the browser's day.
 * @param value - The stored instant. eg '2026-10-19T15:00:00Z'
 * @param timeZone - The opening's IANA zone. eg 'Asia/Tokyo'
 * @returns The day in the app's short date style. eg 'Oct 20, 2026'
 */
export function formatGoalDayAt(value: string, timeZone: string): string {
  return formatShortDate(localDayAt(new Date(value), timeZone) ?? value);
}
